import { render, staticRenderFns } from "./faceRecognition.vue?vue&type=template&id=eaa12e18&scoped=true&"
import script from "./faceRecognition.vue?vue&type=script&lang=js&"
export * from "./faceRecognition.vue?vue&type=script&lang=js&"
import style0 from "./faceRecognition.vue?vue&type=style&index=0&id=eaa12e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa12e18",
  null
  
)

export default component.exports